'use client';

import { type ComponentProps, forwardRef } from 'react';
import Link from 'next/link';
import { mergeProps } from '@frameio/vapor';
import { usePrefetch } from '../hooks/usePrefetch';

/**
 * Next Link rendered in a List, prewired up to use our limited list prefetch strategy
 */
export const ListLinkWithPrefetch = forwardRef<
  HTMLAnchorElement,
  ComponentProps<typeof Link> & { href: string; isGrid?: boolean }
>((props, forwardedRef) => {
  const prefetchProps = usePrefetch(props.href, {
    isNextLink: true,
    placement: 'LIST',
  });

  return (
    <Link
      prefetch={false}
      {...mergeProps(props, prefetchProps)}
      ref={forwardedRef}
    />
  );
});
